import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-empty-state',
  standalone: false,

  templateUrl: './empty-state.component.html',
  styleUrl: './empty-state.component.less'
})
export class EmptyStateComponent {

  @Input() icon: string = '';
  @Input() object: string = '';
  @Input() btnIcon: string = '';
  @Input() btnText: string = '';
  @Input() text: string = 'Haz click en el botón más abajo para crear el primero';
  @Input() customText: string = '';
  @Input() paddingTop: string = '5%';
  @Input() height: string = '70vh';
  @Input() hideBtn?: boolean = false;
  @Input() isSplitBtn?: boolean = false;
  @Output() btnPressEvent = new EventEmitter<void>();
  @Output() secondaryBtnPressEvent = new EventEmitter<void>();

  emitBtnPressEvent(): void {
    this.btnPressEvent.emit();
  }

  emitSecondaryBtnPressEvent(): void {
    this.secondaryBtnPressEvent.emit();
  }

}
